import Component from '../core/Component'
import EventBus from '../core/EventBus'
import { EVENTS } from '../core/Events'

export default class InputsHelper extends Component {
    constructor(element, options = {}) {
        super(element, options)

        this.attachedInputEls = []
    }

    prepare() {
        EventBus.on(EVENTS.DOM_CHANGE, this.handleDomChange)
        setTimeout(() => {
            this.attachInputs()
        }, 1000)
    }

    destroy() {
        EventBus.off(EVENTS.DOM_CHANGE, this.handleDomChange)
    }

    handleDomChange = () => {
        this.attachInputs()
    }

    attachInputs = () => {
        const inputEls = [...document.querySelectorAll('.Input')]
        inputEls.forEach(inputEl => {
            if (this.attachedInputEls.includes(inputEl)) {
                return
            }
            const parentEl = inputEl.closest('.FormItem') ?? inputEl
            const checkValueState = () => {
                parentEl.classList.toggle('is-empty', !inputEl.value)
            }
            const handleFocus = () => {
                parentEl.classList.add('is-focus')
            }
            const handleBlur = () => {
                parentEl.classList.remove('is-focus')
            }
            const handleInput = () => {
                checkValueState()
            }
            parentEl.classList.add('is-ready')
            inputEl.addEventListener('focus', handleFocus)
            inputEl.addEventListener('blur', handleBlur)
            inputEl.addEventListener('input', handleInput)
            checkValueState()
            this.attachedInputEls.push(inputEl)
        })
    }
}